import { Avatar, Box, Typography } from "@mui/material";
import GroupsIcon from "@mui/icons-material/Groups";

const JobsCard = ({card, handleJobClick, index} ) => {

const renderPostedDate = (date) => {
  const postedDate = new Date(date);
  const now = new Date();
  const diffInMs = now - postedDate;

  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  const diffInMonths = Math.floor(diffInDays / 30);
  const diffInYears = Math.floor(diffInDays / 365);

  if (diffInMinutes < 1) {
    return "just now";
  } else if (diffInMinutes < 60) {
    return `${diffInMinutes}m ${diffInMinutes === 1 ? "" :""} ago`;
  } else if (diffInHours < 24) {
    return `${diffInHours}h ${diffInHours === 1 ? "" : ""} ago`;
  } else if (diffInDays === 1) {
    return "1d ago";
  } else if (diffInDays < 30) {
    return `${diffInDays}d ago`;
  } else if (diffInMonths < 12) {
    return `${diffInMonths}m ${diffInMonths === 1 ? "" : ""} ago`;
  } else {
    return `${diffInYears}y ${diffInYears === 1 ? "" : ""} ago`;
  }
};

  const calculateDaysAgo = (date) => {
    const postedDate = new Date(date);
    const today = new Date();
    const differenceInTime = today - postedDate; // Difference in milliseconds
    const differenceInDays = Math.floor(
      differenceInTime / (1000 * 60 * 60 * 24)
    ); // Convert to days
    return differenceInDays;
  };

  return (
    <Box
      key={index}
      onClick={() => handleJobClick(card?.id)}
      sx={{
        padding: "5px", // Reduce padding inside the card
        textAlign: "center",
        border: "1px solid lightgray",
        borderRadius: 2,
        width: "180px", // Reduce width slightly
        minHeight: "200px", // Reduce height slightly
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px", // Reduce space between elements
        cursor: "pointer",
        transition: "all 0.3s ease",
        backgroundColor: "#ffffff",
        boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
        "&:hover": {
          border: "1px solid #0045C6",
        },
      }}
    >
      {/* Avatar */}
      <Avatar
        src={
          card?.company_logo ||
          "https://www.shutterstock.com/image-vector/image-icon-trendy-flat-style-600nw-643080895.jpg"
        }
        sx={{ width: 50, height: 50 }}
      >
        {card?.company_name?.[0] || "?"}
      </Avatar>

      {/* Company Name */}
      <Typography
        variant="subtitle1"
        fontWeight="bold"
        sx={{
          textAlign: "center",
          width: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          fontSize: "14px", // Reduce font size slightly
        }}
      >
        {card?.company_name || "Untitled Company"}
      </Typography>

      {/* Role */}
      <Typography
        variant="body2"
        sx={{
          color: "black",
          textAlign: "center",
          width: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          fontSize: "13px", // Slightly smaller text
        }}
      >
        {card?.role || "No Role Specified"}
      </Typography>

      {/* Date */}
      <Typography
        sx={{
          textAlign: "center",
          width: "100%",
          overflow: "hidden",
          color: "gray",
          fontSize: "11px", // Smaller font for date
        }}
      >
        {renderPostedDate(card?.date_posted) || "No Date Specified"}
      </Typography>
      <Typography
        sx={{
          textAlign: "center",
          width: "100%",
          overflow: "hidden",
          color: "gray",
          fontSize: "11px", // Smaller font for clarity
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "5px", // Adds space between icon and text
        }}
      >
        <GroupsIcon sx={{ fontSize: "18px" }} />
        {card?.applicantStats?.total
          ? `${card.applicantStats.total} applied`
          : "No Applicants"}
      </Typography>
    </Box>
  );
};

export default JobsCard;
